import React from 'react'
import './game_ground.css'
import GameBoard from './GameBoard';
import MyPlayerList from './MyPlayerList';
import Instructions from './Instructions';
import { useState, useEffect } from 'react'
const Playground = (props) => {
    const playerList=props.playerList;
    let randomPlayers=getRandomPlayers(playerList);
    const [myPlayers, setMyPlayers] = useState(randomPlayers.slice(0,8));
    const [opponentPlayers, setOpponentPlayers] = useState(randomPlayers.slice(8,16));

    if(window.innerWidth<=900){
        return(
            <GameBoard isMobile={true} myPlayers={myPlayers} setMyPlayers={setMyPlayers} opponentPlayers={opponentPlayers} setOpponentPlayers={setOpponentPlayers}/>
        )
    }
    else{
        return(
            <div className="full-screen-playground">
            <MyPlayerList playerList={myPlayers}/>
            <GameBoard isMobile={false} myPlayers={myPlayers} setMyPlayers={setMyPlayers} opponentPlayers={opponentPlayers} setOpponentPlayers={setOpponentPlayers}/>
            <Instructions player={myPlayers[0]??opponentPlayers[0]}/>
        </div>
        )
    }
        
    
}

export default Playground;

function getRandomPlayers(playerList)
{
    let randomPlayers=[];
    let idxTaken=[];
    while(randomPlayers.length<16)
    {
        let randomIndex=Math.floor(Math.random()*playerList.length);
        if(idxTaken[randomIndex]!=1)
        {
            randomPlayers.push(playerList[randomIndex]);
            idxTaken[randomIndex]=1;
        }
        
    }
    // console.log(randomPlayers);
    return randomPlayers;
}
